import request from '@/plugins/request';
import { IBoolResult } from '@/types/dto';
import { IUser } from '@/types/models';
import utils from '@/utils';
import { AxiosResponse } from 'axios';

const $url = '/password';

interface IGetResult {
  user: IUser;
}

interface ISubmitRequest {
  password: string;
}

export default {
  get(success: (res: IGetResult) => void) {
    utils.loading(true);
    request
      .get($url)
      .then((response: AxiosResponse<IGetResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },

  submit(req: ISubmitRequest, success: (res: IBoolResult) => void) {
    utils.loading(true);
    request
      .post($url, req)
      .then((response: AxiosResponse<IBoolResult>) => {
        success(response.data);
      })
      .catch(error => {
        utils.error(error);
      })
      .then(() => {
        utils.loading(false);
      });
  },
};
